import axios from "axios";

import {
    IOrganizationClient,
    OrganizationClient,
    IDataProviderClient,
    DataProviderClient,
    UserClient,
    IUserClient,
    ITenantClient,
    TenantClient
} from "../api/clients.api";
import {ApiClientConfig} from "app/modules/common/api/ApiClientConfig";

const hostName = window.location.hostname;
export const apiBaseUrl = hostName == 'localhost' ? 'http://localhost:8080' :'https://app.onlogixs.com';

export class ApiClients {
    organizationClient: IOrganizationClient = null;
    dataProviderClient: IDataProviderClient = null;
    userClient: IUserClient = null;
    tenantClient: ITenantClient = null;

    constructor(configuration: ApiClientConfig) {
        let axiosInstance = axios.create({
            baseURL: apiBaseUrl,
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: (status) => {
                return status >= 200 && status < 500
            }
        });

        axiosInstance.defaults.withCredentials = true;

        this.organizationClient = new OrganizationClient(configuration, apiBaseUrl, axiosInstance);
        this.dataProviderClient = new DataProviderClient(configuration, apiBaseUrl, axiosInstance);
        this.userClient = new UserClient(configuration, apiBaseUrl, axiosInstance);
        this.tenantClient = new TenantClient(configuration, apiBaseUrl, axiosInstance);

        axiosInstance.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            if(error.response?.status == 401) {
                window.location.href = "/login";
            }
        });
    }
}


